import { action, observable } from 'mobx';
import * as api from '../services/api';
import moment from 'moment';


class AllOrdersStore {
    @observable loading = true;
    @observable orders = [];

    @action handleGetAllOrders = (date) => {
        if (!date) {
            date = moment(new Date()).format('DD-MM-YYYY');
        }
        
        api.getAllOrders(date)
            .then(res => {
                if (res) {
                    this.orders = res.filter(order => {
                        const buildingName = order.address?.building_name;
                        const isPopMeals = (buildingName === "Pop Meals Office" || buildingName === "Pop Meals @ Kokubu Food Logistics");
                        return isPopMeals || order.production_started_at;
                    }); 
                    this.orders = this.orders.sort((a,b) => b.order_id - a.order_id);
                }
            })
            .catch(error => console.log(error))
            .finally(() => this.loading = false);
    };
}

const store = new AllOrdersStore();
export default store;
